module.exports = __webpack_public_path__ + "img/sylius-black.3dd9bc7c.png";